import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import './Footer.css';

const Footer = () => {
  return (
    <Box className="footer">
      <Container maxWidth="lg" className="footer-container">
        <Box className="footer-content">
          <Box className="footer-logo">
            <img src="/logo.png" alt="Morales-Autrique Logo" />
            <Typography 
              variant="h6" 
              className="footer-brand"
              sx={{ 
                fontSize: '0.8rem !important',
                fontWeight: 500,
                letterSpacing: '0.15px',
                color: '#283618',
                opacity: 0.7
              }}
            >
              Morales-Autrique
            </Typography>
          </Box>
          <Typography variant="body2" className="footer-copyright">
            © {new Date().getFullYear()} Morales-Autrique
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 